var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.clickMenuItem(_vm.menuItem.url, _vm.menuItem.offset)}}},[_vm._v(_vm._s(_vm.menuItem.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }